// extracted by mini-css-extract-plugin
module.exports = {"detail":"CardlessWithdrawalConfirmation_detail__3YoOD"};